




















import Vue from 'vue';
import { Project } from '@/types';

export default Vue.extend({
  props: {
    projects: {
      type: Array as () => Project[],
    },
  },
});
